module.exports = __webpack_public_path__ + "img/f-blu.47f0afaf.png";